<template>
  <div class="BusinessSystem">
    <div class="close" @click="beginMetting"></div>
  </div>
</template>

<script>
export default {
  methods: {
    beginMetting() {
      this.$emit('beginMetting')
    },
  },
}
</script>

<style lang="less" scoped>
.BusinessSystem {
  width: 1440px;
  height: 768px;
  background: url('../../assets/img/pageCard/XinXiTiShi/YWBG.png') no-repeat
    100%;
  pointer-events: all;
  position: relative;
  transform: translate(-50%, -50%) scale(1) !important;

  .close {
    width: 15px;
    height: 15px;
    position: absolute;
    top: 12px;
    left: 1411px;
  }
}
</style>